<script lang="ts">
    import src from './svg/add_circle_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';
    export let style: string = '';
    export let styleElement: string = '';
</script>

<!--<TemplateIcon {src} {scale} alt={title} hover={title} on:click />-->
<div on:click style="width:{30 * scale}px; height:{30 * scale}px; {styleElement}" class="icon">
    <div style="width:{30 * scale}px; height:{30 * scale}px; {style}" />
</div>
